export default __webpack_public_path__ + "static/media/attachments.398b7c8e.svg";